export default __webpack_public_path__ + "static/media/circle.475816ee.svg";